import React from "react";
import { connect } from "react-redux";
import _ from "lodash";
import {
  Button,
  Card,
  Form,
  Container,
  Row,
  Col,
  InputGroup,
  Tab,
  Tabs,
  Table,
  FormGroup,
  Accordion,
} from "react-bootstrap";
import FuseCollapsiblePanel from "../../FuseCollapsiblePanel";
import FuseInputBox from "../../inputFields/FuseInputBox";

import {
  fetchQueries,
  saveQuery,
  deleteQuery,
  fetchGenericData,
} from "../../../../webservices/generic/genericDataWs";
import {
  showDataFetchError,
  showInfoMessasge,
} from "../../../../actions/generic/fuseAlerts";
import { submitLinkedQuery } from "../../../../actions/generic/genericPageActions";
import { addToastAction } from "../../../../actions/generic/toastActions";
import { ToastTypes } from "../../modals/FuseToast";
import { downloadData } from "../../../../utilities/utilities";
import moment from "moment";
import PropTypes from "prop-types";
class SearchPanel extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isCollapsed: true,
      query: {},
      data: {},
      panelInfo: { ...this.props.panelInfo },
    };
  }

  static defaultProps = {
    myquery: {
      queryId: undefined,
      queryName: undefined,
      origName: undefined,
    },
    onPanelVisible: (panelNumber) => {},
    onPanelHidden: (panelNumber) => {},
  };

  componentDidMount() {
    var panelInfo = this.state.panelInfo;
    panelInfo.searchSize = 100;
    panelInfo.pageSize = 20;
    panelInfo.savedQuery = {
      queryName: "",
      publicQuery: false,
    };

    this.setState({ panelInfo: panelInfo });
    this.props.onPanelVisible(this.props.panelInfo.panelNumber);
    this.autoPopulatePanel(this.props.panelInfo);
  }

  autoPopulatePanel = (panel) => {
    //Execute start up functions (Here default actions happen at start up for example
    //Query received from url, automatic population
    var keyValues = [];
    if (this.props.location.search.includes("searchString=")) {
      var keyword = "searchString=";
      var searchString = this.props.location.search.substr(
        this.props.location.search.indexOf(keyword) + keyword.length,
        this.props.location.search.length
      );

      keyValues = this.getKeyValues(searchString);
    }

    if (panel.autoPopulate === true || !_.isEmpty(keyValues)) {
      if (
        (!keyValues.some((keyValue) => keyValue.colName === "id") &&
          keyValues.length === 0) ||
        keyValues.length === 0
      ) {
        this.submitSearch(panel);
      } else {
        var runsearch = false;

        keyValues.forEach((keyValue, keyValue_index, originalArray) => {
          panel.columns.forEach((col, col_index) => {
            if (col.tableColumn.name === keyValue.colName) {
              col.value = {
                fromValue: keyValue.value,
                toValue: "",
                orderBy: keyValue.orderBy,
              };
              runsearch = true;
              originalArray.splice(keyValue_index, 1);
            }
          });
        });

        var additionalQueryOptions = [];

        if(!_.isEmpty(keyValues)) {
          var additionalQueryOptions = keyValues;
          runsearch = true;
        }

        if (runsearch) {
          this.submitSearch(panel, additionalQueryOptions);
        }
      }
    }
  };

  // Function to get search parameters from url
  getKeyValues = (searchString) => {
    var searchParametes = searchString.split("~");
    var keyValues = [];

    searchParametes.forEach((searchParam, searchParam_index) => {
      var pair = searchParam.split("^");
      if (pair.length > 1) {
        var keyValue = {
          colName: pair[0],
          value: this.getAppropriateValue(pair[1]),
          orderBy: pair[2],
        };
        keyValues.push(keyValue);
      }
    });

    return keyValues;
  };

  // Function to set values so that it populates the search panel correctly
  getAppropriateValue = (value) => {
    if(value.toString().toUpperCase().includes("TRUE") || value.toString().toUpperCase().includes("FALSE")) {
      value = value.substring(value.indexOf("=")+1);
    }

    return value;
  }

  onViewOptions = (isCollapsed) => {
    this.setState({ isCollapsed: !isCollapsed });
  };

  searchSizeChanged = (value) => {
    var panelInfo = this.state.panelInfo;
    if (value > 1000) {
      value = 1000;
    }
    panelInfo.searchSize = value;

    this.setState({
      panelInfo: panelInfo,
    });
  };

  pageSizeChanged = (value) => {
    var panelInfo = this.state.panelInfo;
    if (value > 1000) {
      value = 1000;
    }
    panelInfo.pageSize = value;

    this.setState({
      panelInfo: panelInfo,
    });
  };

  //Function: This loads a saved query that is selected from the saved queries dropdown
  savedQuerySelected = () => {
    var panel = this.state.panelInfo;

    panel.savedQuery.origName = panel.savedQuery.queryName;
    panel.columns.forEach((column, index) => {
      column.value = {
        fromValue: "",
        toValue: "",
        orderBy: "",
      };

      var searchColumn = null;
      if (panel.savedQuery.queryOptions !== undefined) {
        searchColumn = Object.values(panel.savedQuery.queryOptions).filter(
          (queryOption) => queryOption.columnName === column.tableColumn.name
        );
      }

      if (searchColumn !== null) {
        searchColumn.forEach((item, index) => {
          if (column.tableColumn.name === item.columnName) {
            if (item.value.substring(0, 1) === "=") {
              item.value = item.value.replace("=", "");
            }

            if (item.value.indexOf(",") !== -1) {
              var listValues = item.value.split(",");

              //if dropdown
              if (column.columnType === "dropdown") {
                column.value.fromValue = listValues;
              } else {
                column.value.fromValue = item.value;
              }
            } else {
              column.value.fromValue = item.value;
            }

            if (item.value && item.orderBy === "DESC") {
              column.value.orderBy = "descending";
            } else if (item.value && item.orderBy === "ASC") {
              column.value.orderBy = "ascending";
            } else {
              column.value.orderBy = "";
            }
          }
        });

        var searchColumn = Object.values(
          panel.savedQuery.aggregateOptions
        ).filter(
          (aggregateOption) =>
            aggregateOption.columnName === column.tableColumn.name
        );
        if (searchColumn !== null) {
          searchColumn.forEach((aggregateItem, index) => {
            if (column.tableColumn.name === aggregateItem.columnName) {
              if (aggregateItem.aggregateType === "group_by") {
                column.value.groupByOrder = aggregateItem.aggregateOrder;
                column.value.groupBy = true;
              } else if (aggregateItem.aggregateType === "total") {
                column.value.totalOrder = aggregateItem.aggregateOrder;
                column.value.total = true;
              } else if (aggregateItem.aggregateType === "min") {
                column.value.minOrder = aggregateItem.aggregateOrder;
                column.value.min = true;
              } else if (aggregateItem.aggregateType === "max") {
                column.value.maxOrder = aggregateItem.aggregateOrder;
                column.value.max = true;
              } else if (aggregateItem.aggregateType === "avg") {
                column.value.avgOrder = aggregateItem.aggregateOrder;
                column.value.avg = true;
              } else if (aggregateItem.aggregateType === "sum") {
                column.value.sumOrder = aggregateItem.aggregateOrder;
                column.value.sum = true;
              }
            }
          });
        }
      }
    });
  };

  // Function: This function get all the queries that is used in the main Filters
  fetchQueries = () => {
    var panel = this.state.panelInfo;

    var query = {
      schema: panel.table.schema,
      tableName: panel.table.name,
      queryOptions: [],
      aggregateOptions: [],
      searchSize: panel.searchSize,
      screenId: this.props.screenId,
      queryName: this.props.myquery.queryName,
      queryId: this.props.myquery.queryId,
    };

    fetchQueries(Number(this.props.screenId), this.props.panelId)
      .then((response) => {
        var data = response.data;
        panel.savedQueries = data.result;
        panel.savedQuery = {};

        panel.columns.forEach((column, index) => {
          column.value = {
            fromValue: "",
            toValue: "",
            orderBy: "",
          };
        });

        // this.setState({ panelInfo: panel });
      })
      .catch((error) => {
        console.log("Error: " + error);
      });
  };

  //Initialises the aggregate tab values
  initAggregate = (column) => {
    if (!column.value || column.value === undefined) {
      column.value = {};
    }

    column.value.groupBy = false;
    column.value.total = false;
    column.value.min = false;
    column.value.max = false;
    column.value.avg = false;
    column.value.sum = false;

    column.value.groupByOrder = 0;
    column.value.totalOrder = 0;
    column.value.minOrder = 0;
    column.value.maxOrder = 0;
    column.value.avgOrder = 0;
    column.value.sumOrder = 0;
  };

  //This is for the aggregate tab values
  updateTracker = (event, col) => {
    var panel = this.state.panelInfo;
    panel.orderTracker =
      panel.orderTracker === undefined ? 1 : panel.orderTracker + 1;
    var value = panel.orderTracker;

    col.value[event.target.name] = event.target.checked;
    col.value[event.target.name + "Order"] = value;

    this.setState({ panelInfo: panel });
  };

  //Save values to the component's state
  updateValue = (type, col, value) => {
    switch (type) {
      case "FROM":
        if (col.columnType === "dropdown") {
          if (
            (_.isEmpty(col.value.fromValue) && !_.isArray(value)) ||
            !_.isArray(value)
          ) {
            // col.value.fromValue = [value];
            col.value.fromValue = value;
          } else {
            col.value.fromValue = value;
          }
        } else {
          col.value.fromValue = value;
        }
        break;
      case "TO":
        col.value.toValue = value;
        break;
      default:
        col.value.orderBy = value;
        break;
    }

    this.setState({ panelInfo: this.state.panelInfo });
  };

  //Gets the from date value
  dateFromChange = (col, value) => {
    if (value === "" || value === undefined || value === null) {
      col.value.fromValue = null;
    } else {
      col.value.fromValue = moment(value).format("YYYY-MM-DD");
    }
    // console.log("dateFromChange", col.value.fromValue);
    this.setState({ panelInfo: this.state.panelInfo });
  };

  //Gets the to date value
  dateToChange = (col, value) => {
    if (value === "" || value === undefined || value === null) {
      col.value.toValue = null;
    } else {
      col.value.toValue = moment(value).format("YYYY-MM-DD");
    }
    this.setState({ panelInfo: this.state.panelInfo });
  };

  //Saves query information on the manage queries tab
  updateSavedQuery(e) {
    var panel = this.state.panelInfo;
    var value = e.target.value;

    if (typeof value == "boolean") {
      panel.savedQuery[e.target.name] = !!e.target.value;
    } else {
      panel.savedQuery[e.target.name] = e.target.value;
    }

    this.setState({
      panelInfo: panel,
    });
  }

  // Function: This function executes the query all action to update all linked and child panels
  submitSearch = (newPanel, additionalQueryOptions) => {
    var panel = newPanel != undefined ? newPanel : this.state.panelInfo;
    var queryOptions = [];
    var aggregateOptions = [];
    var tmpSearchString = "";

    let query = {
      screenId: this.props.screenId,
      schema: panel.table.schema,
      tableName: panel.table.name,
      //panelId: 2, //The linked panel will add its panelId to fetch its own data
      queryOptions: [], //Todo:This should be built up dynamically from input!!!
      aggregateOptions: [], //Todo:This should be built up dynamically from input!!!
      searchSize: panel.searchSize ? panel.searchSize : 100, //Todo:This should be built up dynamically from input!!!
      pageSize: panel.pageSize ? panel.pageSize : 20,
      customWhereClause: panel.customWhereClause, //Todo:This should be built up dynamically from input!!!
    };

    // This is creating the query and aggregate option items
    panel.columns.forEach((column) => {
      if (column.value) {
        var res = this.generateQueryOptionItem(
          column.tableColumn.name,
          column.value
        );
        if (res) {
          query.queryOptions.push(res);
          tmpSearchString +=
            res.columnName + "^" + res.value + "^" + res.orderBy + "~";
        }
        this.generateAggregateOptionItem(
          column.tableColumn.name,
          column.value,
          query.aggregateOptions
        );
      }
    });

    if(additionalQueryOptions && additionalQueryOptions.length > 0) {
      additionalQueryOptions.forEach((option, option_index) => {
        if (option.value) {
          var newValue = {
            fromValue: option.value,
            toValue: '',
            orderBy: (option.orderBy) ? option.orderBy : ''
          }

          var res = this.generateQueryOptionItem(
            option.colName,
            newValue
          );
          if (res) {
            query.queryOptions.push(res);
            tmpSearchString +=
              res.columnName + "^" + res.value + "^" + res.orderBy + "~";
          }
        }
      });
    }

    this.props.submitLinkedQuery(panel, this.props.screenId, query);
    this.setState({ query: query, panelInfo: panel });
  };

  onMoreFewerOptions = (e) => {
    var buttonText = e.target.textContent;
    e.target.textContent =
      buttonText === "More options" ? "Fewer options" : "More options";
    this.setState({ isCollapsed: !this.state.isCollapsed });
  };

  // Requesting to download a file from the search panel using the download button
  requestDownload = () => {
    var panel = this.state.panelInfo;

    var queryOptions = [];
    var aggregateOptions = [];
    var tmpSearchString = "";

    let query = {
      screenId: this.props.screenId,
      schema: panel.table.schema,
      tableName: panel.table.name,
      panelId: panel.linkedPanels[0].panelNumber,
      panelNumber: panel.linkedPanels[0].panelNumber,
      queryOptions: [],
      aggregateOptions: [],
      searchSize: panel.searchSize,
      pageSize: panel.pageSize,
      customWhereClause: panel.customWhereClause,
    };

    // This is creating the query and aggregate option items
    panel.columns.forEach((column) => {
      if (column.value) {
        var s = {};
        var res = this.generateQueryOptionItem(
          column.tableColumn.name,
          column.value
        );
        if (res) {
          query.queryOptions.push(res);
          tmpSearchString +=
            res.columnName + "^" + res.value + "^" + res.orderBy + "~";
        }
        this.generateAggregateOptionItem(
          column.tableColumn.name,
          column.value,
          query.aggregateOptions
        );
      }
    });

    // Required for downloading file
    var options = {
      fileName: this.props.screenInfo.name,
      fileType: "csv",
      separator: ",",
    };

    fetchGenericData(query)
      .then((response) => {
        if (!_.isEmpty(response.error)) {
          console.log("Error fetching generic data:");
          console.log(JSON.stringify(response.error));
          this.props.showDataFetchError(response.error.message);
        } else if (response.data.success === true) {
          let data = response.data.result.data;
          downloadData(data, panel.columns, options, (callback) => {
            this.props.showInfoMessasge(
              "There are no records matching that filters.\r\nConsider changing your filters and try again."
            );
          });
        } else {
          console.log("Error fetching generic data:");
          console.log(JSON.stringify(response.data));
          this.props.showDataFetchError();
        }
      })
      .catch(function (error) {
        console.log("exception:" + error);
        this.props.showDataFetchError(error.message);
      });
  };

  //Function: This clears the entire search panel except the main filters
  clearPanel = () => {
    var panel = this.state.panelInfo;

    panel.columns.forEach(function (column, index) {
      column.value = {
        fromValue: "",
        toValue: "",
        orderBy: "",
      };
    });
    panel.savedQuery = {
      queryName: "",
      publicQuery: false,
    };
    panel.orderTracker = 0;
    panel.searchSize = 100;
    panel.pageSize = 20;
    this.setState({ panelInfo: panel });
  };

  //Function: This runs the main count
  runCount = () => {
    var panel = this.state.panelInfo;

    var query = {};
    query.schema = panel.table.schema;
    query.tableName = panel.table.name;
    query.queryOptions = [];
    query.panelId = this.props.panelId;
    query.screenId = this.props.screenId;

    panel.columns.forEach(function (column, index) {
      if (column.value) {
        var s = {};
        // var res = generateQueryOptionItem(column.tableColumn.name, column.value);

        // if (res) {
        //   query.queryOptions.push(res);
        // }
      }
    });
  };

  // Function: This is used to create query options for the submit search function
  generateQueryOptionItem = (columnName, controlValue) => {
    var queryItem = null;
    var value = "";
    if (controlValue.fromValue && controlValue.fromValue != "") {
      if (controlValue.fromValue instanceof Date) {
        var yyyy = controlValue.fromValue.getFullYear().toString();
        var mm = (controlValue.fromValue.getMonth() + 1).toString(); // getMonth() is zero-based
        if (mm < 10) {
          mm = "0" + mm;
        }
        var dd = controlValue.fromValue.getDate().toString();
        if (dd < 10) {
          dd = "0" + dd;
        }
        value += "=" + yyyy + "-" + mm + "-" + dd;
      } else if (
        controlValue.fromValue instanceof Array &&
        controlValue.fromValue.indexOf(",") === -1
      ) {
        value +=
          "=" + controlValue.fromValue.map((value) => value.value).toString();
      } else {
        //ie11 check, startsWith not supported
        if (!String.prototype.startsWith) {
          //if ie11
          if (controlValue.fromValue.indexOf("=") == 0) {
            value += "=" + controlValue.fromValue;
          } else {
            value += controlValue.fromValue;
          }
        } else {
          var frmValStr = controlValue.fromValue + "";
          if (!frmValStr.startsWith("=")) {
            value += "=" + controlValue.fromValue;
          } else {
            value += controlValue.fromValue;
          }
        }
      }
    }

    if (controlValue.toValue && controlValue.toValue != "") {
      if (value.indexOf("=") >= 0) {
        value = ">" + value;
      }

      if (controlValue.toValue != "") {
        if (value != "") {
          value += " AND ";
        }

        if (controlValue.toValue instanceof Date) {
          var yyyy = controlValue.toValue.getFullYear().toString();
          var mm = (controlValue.toValue.getMonth() + 1).toString(); // getMonth() is zero-based
          var dd = controlValue.toValue.getDate().toString();
          if (mm < 10) {
            mm = "0" + mm;
          }
          if (dd < 10) {
            dd = "0" + dd;
          }
          value += "<=" + yyyy + "-" + mm + "-" + dd;
        } else {
          value += "<=" + controlValue.toValue;
        }
      }
    }

    if (value != "" || controlValue.orderBy != "") {
      var tmpV;
      if (controlValue.orderBy == "descending") {
        tmpV = "DESC";
      } else if (controlValue.orderBy == "ascending") {
        tmpV = "ASC";
      }
      if (tmpV || value) {
        queryItem = {
          columnName: columnName,
          value: value,
          orderBy: tmpV,
        };
      }
    }

    return queryItem;
  };

  // Function: This is used to create aggregate options for the submit search function
  generateAggregateOptionItem = (columnName, controlValue, aggregateArray) => {
    var aggregateItem = null;

    if (controlValue.groupBy && controlValue.groupBy == true) {
      aggregateItem = {
        columnName: columnName,
        aggregateOrder: controlValue.groupByOrder,
        aggregateType: "group_by",
      };
      aggregateArray.push(aggregateItem);
    }

    if (controlValue.total && controlValue.total == true) {
      aggregateItem = {
        columnName: columnName,
        aggregateOrder: controlValue.totalOrder,
        aggregateType: "total",
      };
      aggregateArray.push(aggregateItem);
    }

    if (controlValue.min && controlValue.min == true) {
      aggregateItem = {
        columnName: columnName,
        aggregateOrder: controlValue.minOrder,
        aggregateType: "min",
      };
      aggregateArray.push(aggregateItem);
    }

    if (controlValue.max && controlValue.max == true) {
      aggregateItem = {
        columnName: columnName,
        aggregateOrder: controlValue.maxOrder,
        aggregateType: "max",
      };
      aggregateArray.push(aggregateItem);
    }

    if (controlValue.avg && controlValue.avg == true) {
      aggregateItem = {
        columnName: columnName,
        aggregateOrder: controlValue.avgOrder,
        aggregateType: "avg",
      };
      aggregateArray.push(aggregateItem);
    }

    if (controlValue.sum && controlValue.sum == true) {
      aggregateItem = {
        columnName: columnName,
        aggregateOrder: controlValue.sumOrder,
        aggregateType: "sum",
      };
      aggregateArray.push(aggregateItem);
    }

    return aggregateItem;
  };

  // Function: Used to delete queries on the manage queries tab
  deleteQuery() {
    var panel = this.state.panelInfo;

    var query = {
      schema: panel.table.schema,
      tableName: panel.table.name,
      queryOptions: [],
      aggregateOptions: [],
      searchSize: panel.searchSize,
      screenId: this.props.screenId,
      queryName: panel.savedQuery.queryName,
      queryId: panel.savedQuery.queryId,
    };

    deleteQuery(Number(this.props.screenId), this.props.panelId)
      .then((response) => {
        var data = response.data;
        panel.savedQueries = data;
        panel.savedQuery = {
          queryName: "",
          publicQuery: false,
        };

        panel.columns.forEach((column, index) => {
          column.value = {
            fromValue: "",
            toValue: "",
            orderBy: "",
          };
        });

        //Display Success Toast
        this.props.addToast(
          ToastTypes.SUCCESS,
          "Query has been deleted successfully"
        );
      })
      .catch(function (error) {
        console.log("Error: " + error);
        //Display Error Toast
        this.props.addToast(ToastTypes.ERROR, "Error deleting query");
      });
  }

  // Function: Used to save queries on the manage queries tab
  saveQuery() {
    var panel = this.state.panelInfo;

    var query = {
      schema: panel.table.schema,
      tableName: panel.table.name,
      queryOptions: [],
      aggregateOptions: [],
      searchSize: panel.searchSize,
      panelId: this.props.panelId,
      screenId: Number(this.props.screenId),
      queryName: panel.savedQuery.queryName,
      queryId: panel.savedQuery.queryId,
    };

    if (
      panel.savedQuery.publicQuery === undefined ||
      panel.savedQuery.publicQuery === ""
    ) {
      panel.savedQuery.queryId = undefined;
    }

    query.publicQuery = !!panel.savedQuery.publicQuery;

    if (panel.savedQuery.origName !== panel.savedQuery.queryName) {
      panel.savedQuery.queryId = undefined;
    }

    if (
      query.queryName === "" ||
      query.queryName === undefined ||
      query.queryName === null
    ) {
      query.queryName = "My Query";
    }

    panel.columns.forEach((column, index) => {
      if (column.value) {
        var res = this.generateQueryOptionItem(
          column.tableColumn.name,
          column.value
        );
        if (res) {
          query.queryOptions.push(res);
        }
        this.generateAggregateOptionItem(
          column.tableColumn.name,
          column.value,
          query.aggregateOptions
        );
      }
    });

    saveQuery(query)
      .then((response) => {
        var data = response.data;
        panel.savedQueries = data;
        panel.savedQuery = {
          queryName: "",
          publicQuery: false,
        };

        panel.columns.forEach((column, index) => {
          column.value = {
            fromValue: "",
            toValue: "",
            orderBy: "",
          };
        });

        //Display Success Toast
        this.props.addToast(
          ToastTypes.SUCCESS,
          "Query has been saved successfully"
        );
      })
      .catch(function (error) {
        console.log("Error: " + error);
        //Display Error Toast
        this.props.addToast(ToastTypes.ERROR, "Error saving query");
        this.props.showDataFetchError(error.message);
      });
  }

  render() {
    if (
      _.isEmpty(this.props.screenInfo) ||
      _.isEmpty(this.props.screenInfo.panels)
    ) {
      return null;
    }

    const mainFilters = () => {
      return (
        <Row className="mb-3">
          {/* <Col sm={12} md={6} lg={5} xl={5}>
            <InputGroup>
              <InputGroup.Prepend>
                <InputGroup.Text id="inputGroup-sizing-sm">
                  Saved Query
                </InputGroup.Text>
              </InputGroup.Prepend>
              <select
                className="input-sm form-control"
                placeholder="User Query"
                aria-describedby="basic-addon1"
                value={
                  this.state.panelInfo.savedQuery === undefined
                    ? ""
                    : this.state.panelInfo.savedQuery
                }
                onChange={() => {
                  this.savedQuerySelected();
                }}
              >
                <option></option>
                {this.state.panelInfo.savedQueries !== undefined &&
                  this.state.panelInfo.savedQueries.map((query) => {
                    return (
                      <option value={query.queryId}>{query.queryName}</option>
                    );
                  })}
                ;
              </select>
            </InputGroup>
          </Col> */}
          <Col sm={4} lg={3} xl={2}>
            <InputGroup>
              <InputGroup.Prepend>
                <InputGroup.Text id="inputGroup-sizing-sm">
                  Search Size
                </InputGroup.Text>
              </InputGroup.Prepend>
              <input
                type="number"
                min="10"
                max="1000"
                className="input-sm form-control"
                value={
                  this.state.panelInfo.searchSize === undefined
                    ? "100"
                    : this.state.panelInfo.searchSize
                }
                onChange={(e) => {
                  this.searchSizeChanged(e.target.value);
                }}
              />
            </InputGroup>
          </Col>
          <Col sm={4} lg={4} xl={2}>
            <InputGroup>
              <InputGroup.Prepend>
                <InputGroup.Text id="inputGroup-sizing-sm">
                  Page Size
                </InputGroup.Text>
              </InputGroup.Prepend>
              <input
                type="number"
                min="10"
                max="1000"
                className="input-sm form-control"
                value={
                  this.state.panelInfo.pageSize === undefined
                    ? "20"
                    : this.state.panelInfo.pageSize
                }
                onChange={(e) => {
                  this.pageSizeChanged(e.target.value);
                }}
              />
            </InputGroup>
          </Col>
        </Row>
      );
    };

    const filterTabs = () => {
      return (
        <Tabs defaultActiveKey="simple" variant="pills">
          <Tab eventKey="simple" title="Simple">
            <Table responsive className="mb-2">
              <thead>
                <tr>
                  <th className="search-panel-filter-header">Column</th>
                  <th className="search-panel-filter-header">From</th>
                  <th className="search-panel-filter-header">To</th>
                  <th className="search-panel-filter-header">Order By</th>
                </tr>
              </thead>
              <tbody>
                {this.state.panelInfo.columns
                  .filter((column) => column.visible)
                  .map((col) => {
                    let key = `${col.tableColumn.name}_${col.tableColumn.id}`;
                    let id = `${col.tableColumn.id}`;

                    if (col.value === undefined) {
                      col.value = {
                        fromValue: "",
                        toValue: "",
                        orderBy: "",
                      };
                    }

                    return (
                      <tr key={`${key}`}>
                        {/* Column Description */}
                        <td className="search-panel-data-column">
                          {col.tableColumn.description}
                        </td>

                        {/* From Column */}
                        <td className="search-panel-data-column">
                          {(col.columnType === "String" ||
                            col.columnType === "Int32" ||
                            col.columnType === "Int64" ||
                            col.columnType === "Double" ||
                            col.columnType === "address_text") && (
                            <FuseInputBox
                              id={id}
                              classes={"fuse-form-control"}
                              name={`${col.tableColumn.name}`}
                              type={col.tableColumn.columnType}
                              editable={true}
                              required={false}
                              showErrors={false}
                              isValid={() => {
                                return true;
                              }}
                              value={
                                col.value === undefined
                                  ? ""
                                  : col.value.fromValue
                              } //{ row[column.tableColumn.name] }
                              onChange={(val) => {
                                this.updateValue("FROM", col, val);
                              }}
                            />
                          )}
                          {col.columnType === "DateTime" && (
                            <FuseInputBox
                              id={id}
                              classes={"fuse-form-control"}
                              name={`${col.tableColumn.name}`}
                              type={col.columnType}
                              editable={true}
                              required={false}
                              showErrors={false}
                              isValid={() => {
                                return true;
                              }}
                              value={
                                col.value === undefined
                                  ? null
                                  : col.value.fromValue
                              } //{ row[col.tableColumn.name] }
                              onChange={(val) => {
                                // console.log("panel:", val);
                                this.dateFromChange(col, val);
                              }}
                            />
                          )}
                          {col.columnType === "Boolean" && (
                            <FuseInputBox
                              id={id}
                              classes={"fuse-form-control"}
                              type={`dropdown`}
                              isClearable
                              isSearchable
                              isMulti={false}
                              editable={true}
                              required={false}
                              showErrors={false}
                              menuPortalTarget={document.body}
                              className="col-sm-12"
                              value={col.value.fromValue}
                              dropKeyColumn="key"
                              dropValueColumn="value"
                              dropDownValues={[
                                { key: "All", value: "All" },
                                { key: "Empty", value: "Empty" },
                                { key: "True", value: "True" },
                                { key: "False", value: "False" },
                              ]}
                              isValid={() => {
                                return true;
                              }}
                              onChange={(val) => {
                                this.updateValue("FROM", col, val);
                              }}
                            />
                          )}
                          {col.columnType === "dropdown" && (
                            <FuseInputBox
                              classes={"fuse-form-control"}
                              type={col.columnType}
                              isClearable
                              isSearchable
                              editable={true}
                              isMulti={false}
                              required={false}
                              showErrors={false}
                              menuPortalTarget={document.body}
                              className="col-sm-12"
                              value={col.value.fromValue}
                              dropKeyColumn="key"
                              dropValueColumn="value"
                              dropDownValues={col.dropDownValues}
                              dropDownDisplayValues={col.dropDownDisplayValues}
                              isValid={() => {
                                return true;
                              }}
                              onChange={(val) => {
                                this.updateValue("FROM", col, val);
                              }}
                            />
                          )}
                          {col.columnType === "list_of_values" && (
                            <FuseInputBox
                              id={id}
                              classes={"fuse-form-control"}
                              name="sampleDate"
                              type="list_of_values"
                              value={
                                col.value === undefined
                                  ? ""
                                  : col.value.fromValue
                              } //{ row[col.tableColumn.name] }
                              lovTable={col.additionalSourceTable}
                              lovKeyColumn={col.additionalSourceKey}
                              lovValueColumn={col.additionalSourceValue}
                              editable={true}
                              required={false}
                              showErrors={false}
                              onChange={(val) => {
                                this.updateValue("FROM", col, val);
                              }}
                            />
                          )}
                        </td>

                        {/* To Column */}
                        <td className="search-panel-data-column">
                          {col.columnType === "DateTime" && (
                            <div>
                              <FuseInputBox
                                id={id}
                                classes={"fuse-form-control"}
                                name={`${col.tableColumn.name}`}
                                type="DateTime"
                                isValid={() => {
                                  return true;
                                }}
                                value={
                                  col.value === undefined
                                    ? null
                                    : col.value.toValue
                                } //{ row[col.tableColumn.name] }
                                editable={true}
                                required={false}
                                showErrors={false}
                                onChange={(val) => {
                                  this.dateToChange(col, val);
                                }}
                              />
                            </div>
                          )}
                        </td>

                        {/* Order By Column */}
                        <td className="search-panel-data-column">
                          <FuseInputBox
                            classes={"fuse-form-control"}
                            type={"dropdown"}
                            isClearable
                            isSearchable
                            editable={true}
                            isMulti={false}
                            menuPortalTarget={document.body}
                            className="col-sm-12"
                            value={
                              col.value === undefined ? "" : col.value.orderBy
                            }
														dropKeyColumn="key"
														dropValueColumn="value"
                            dropDownValues={[
                              { key: "ascending", value: "Ascending" },
                              { key: "descending", value: "Descending" },
                            ]}
                            dropDownDisplayValues={[
                              { key: "ascending", value: "Ascending" },
                              { key: "descending", value: "Descending" },
                            ]}
                            isValid={() => {
                              return true;
                            }}
                            onChange={(val) => {
                              this.updateValue("ORDERBY", col, val);
                            }}
                          />
                        </td>
                      </tr>
                    );
                  })}
              </tbody>
            </Table>
          </Tab>
          <Tab eventKey="aggregate" title="Aggregate">
            <Table responsive>
              <thead>
                <tr>
                  <th className="search-panel-filter-header">Column</th>
                  <th className="search-panel-filter-header">Group By</th>
                  <th className="search-panel-filter-header">Total</th>
                  <th className="search-panel-filter-header">Min</th>
                  <th className="search-panel-filter-header">Max</th>
                  <th className="search-panel-filter-header">Avg</th>
                  <th className="search-panel-filter-header">Sum</th>
                </tr>
              </thead>

              <tbody>
                {this.state.panelInfo.columns
                  .filter((column) => column.visible)
                  .map((col, index) => {
                    return (
                      <tr key={`${index}`}>
                        <td>{col.tableColumn.description}</td>
                        <td>
                          <input
                            type="checkbox"
                            name="groupBy"
                            checked={
                              col.value === undefined
                                ? false
                                : col.value.groupBy
                            }
                            value={
                              col.value === undefined
                                ? false
                                : col.value.groupBy
                            }
                            onChange={(e) => this.updateTracker(e, col)}
                          />
                        </td>
                        <td>
                          <input
                            type="checkbox"
                            name="total"
                            checked={
                              col.value === undefined ? false : col.value.total
                            }
                            value={false}
                            onChange={(e) => this.updateTracker(e, col)}
                          />
                        </td>
                        <td>
                          {(col.columnType === "Int64" ||
                            col.columnType === "Int32" ||
                            col.columnType === "Double" ||
                            col.columnType === "DateTime") && (
                            <input
                              type="checkbox"
                              name="min"
                              checked={
                                col.value === undefined ? false : col.value.min
                              }
                              value={false}
                              onChange={(e) => this.updateTracker(e, col)}
                            />
                          )}
                        </td>
                        <td>
                          {(col.columnType === "Int64" ||
                            col.columnType === "Int32" ||
                            col.columnType === "Double" ||
                            col.columnType === "DateTime") && (
                            <input
                              type="checkbox"
                              name="max"
                              checked={
                                col.value === undefined ? false : col.value.max
                              }
                              value={false}
                              onChange={(e) => this.updateTracker(e, col)}
                            />
                          )}
                        </td>
                        <td>
                          {(col.columnType === "Int64" ||
                            col.columnType === "Int32" ||
                            col.columnType === "Double") && (
                            <input
                              type="checkbox"
                              name="avg"
                              checked={
                                col.value === undefined ? false : col.value.avg
                              }
                              value={false}
                              onChange={(e) => this.updateTracker(e, col)}
                            />
                          )}
                        </td>
                        <td>
                          {(col.columnType === "Int64" ||
                            col.columnType === "Int32" ||
                            col.columnType === "Double") && (
                            <input
                              type="checkbox"
                              name="sum"
                              checked={
                                col.value === undefined ? false : col.value.sum
                              }
                              value={false}
                              onChange={(e) => this.updateTracker(e, col)}
                            />
                          )}
                        </td>
                      </tr>
                    );
                  })}
              </tbody>
            </Table>
          </Tab>
          {/* <Tab eventKey="manageQueries" title="Manage Queries">
                  <Form className="search-panel-form">
                    <FormGroup>
                      <Row>
                        <Col className="col-xs-12">
                          <h2>Manage Queries</h2>
                        </Col>
                      </Row>
                      <Row>
                        <Col className="col-xs-4">
                          <label>Query name</label>
                          <input type="text" className="form-control" name="queryName" placeholder="Query Name" value={(this.state.panelInfo.savedQuery === undefined) ? '' : this.state.panelInfo.savedQuery.queryName} onChange={(e) => { this.updateSavedQuery(e); }} />
                        </Col>

                        <Col className="col-xs-4 col-lg-offset-1">
                          <label>Query Available to everyone</label>
                          <input type="checkbox" className="form-control" name="publicQuery" checked={(this.state.panelInfo.savedQuery === undefined) ? false : this.state.panelInfo.savedQuery.publicQuery} onChange={(e) => { this.updateSavedQuery(e); }} />
                        </Col>
                      </Row>
                      <br />
                      <Row>
                        <Col className="col-xs-4">
                          <ButtonGroup>
                            <Button className="btn btn-danger" onClick={() => { this.deleteQuery() }}>Delete</Button>
                            <Button className="btn btn-success" onClick={() => { this.saveQuery() }}>Save</Button>
                          </ButtonGroup>
                        </Col>
                      </Row>
                    </FormGroup>
                  </Form>
                </Tab> */}
        </Tabs>
      );
    };

    return (
      <FuseCollapsiblePanel title={this.state.panelInfo.header}>
        <Container fluid>
          {mainFilters()}
          <Accordion>
            <Accordion.Collapse eventKey="0">
              <Card border="light">
                <Card.Body>{filterTabs()}</Card.Body>
              </Card>
            </Accordion.Collapse>

            <div
              className={`float-right mt-1 mr-3 ${
                this.state.isCollapsed ? "search-panel-action-buttons" : ""
              }`}
            >
              <Accordion.Toggle
                as={Button}
                eventKey="0"
                onClick={(e) => this.onMoreFewerOptions(e)}
              >
                <div className="d-flex justify-content-between">
                  <span>{"More options"}</span>
                </div>
              </Accordion.Toggle>
              <Button
                className="search-panel-action-button"
                onClick={() => {
                  this.clearPanel();
                }}
              >
                Clear
              </Button>
              {/* {!this.state.isCollapsed && <Button className="search-panel-action-button" onClick={this.runCount()}>Count</Button>} */}
              {!this.state.isCollapsed && (
                <Button
                  className="search-panel-action-button"
                  onClick={() => {
                    this.requestDownload();
                  }}
                >
                  <i className="fa fa-download" /> Download
                </Button>
              )}
              <Button
                className="search-panel-action-button"
                onClick={() => {
                  this.submitSearch();
                }}
              >
                <i className="fa fa-search" /> Find
              </Button>
            </div>
          </Accordion>
        </Container>
      </FuseCollapsiblePanel>
    );
  }
}

SearchPanel.propTypes = {
  //fetchScreenInfo: PropTypes.func.isRequired
  // panelId: PropTypes.number.isRequired,
  // screenId: PropTypes.number.isRequired
};

const mapStateToProps = (state, ownProps) => {
  return {
    fetchingData: state.fetchingData === true,
    auth: state.auth,
    screenInfo: state.screenInfo,
    panelInfo:
      !_.isEmpty(state.screenInfo) && !_.isEmpty(state.screenInfo.panels)
        ? state.screenInfo.panels.filter((x) => x.id === ownProps.panelId)[0]
        : {},
  };
};

export default connect(
  // map state to props
  mapStateToProps,
  // map dispatch to props
  (dispatch, ownProps) => ({
    showDataFetchError: (exception) => dispatch(showDataFetchError(exception)),
    showInfoMessasge: (infoMessage) => dispatch(showInfoMessasge(infoMessage)),
    submitLinkedQuery: (panel, screenId, query) =>
      dispatch(submitLinkedQuery(panel, screenId, query)),
    addToast: (type, text) => dispatch(addToastAction(type, text)),
  }),
  null,
  { forwardRef: true }
)(SearchPanel);
